<template>
	<div class="top-bar"></div>
</template>

<script>
export default {
	methods: {
		openProductSelector() {
			this.$store.commit('setProductSelectorOpen', true)
		}
	}
}
</script>

<style lang="scss" scoped>
.top-bar {
	top: 0;
	left: 0;
	width: 100%;
	height: 30px;
	position: absolute;
	display: flex;
	font-size: 14px;
	background-color: $clrGrey400;

	button {
		height: 100%;
		padding: 0 15px;
		position: relative;
		display: flex;
		align-items: center;
		color: $clrGrey200;
		font-weight: 500;

		&:hover {
			background-color: $clrGrey300;
			color: #ffffff;
		}
		&:active, &.active {
			background-color: $clrGrey450;
		}

		svg {
			width: 30px;
			height: 100%;
		}

		> span {
			display: inline-block;
			padding-bottom: 1px;
			margin: 0 10px;
		}

		&::after {
			content: "";
			top: 5px;
			right: 0;
			width: 1px;
			height: 20px;
			position: absolute;
			background-color: $clrGrey300;
		}
	}

	&__left {
		width: 60px;
	}

	&__more {
		svg {
		}
	}

}
</style>
